export default function GetUnlimiterIcon() {
  return (
    <svg width='20' height='20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#a)'>
        <path
          d='M9.166 17.5h-.833l.833-5.833h-3.55S8.683 6.283 10.833 2.5h.833l-.833 5.833h3.566L9.166 17.5Z'
          fill='#fff'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h20v20H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}
